import React, { useContext, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { WheelAndTorqueContext } from './WheelRemoveContext';
import { CustomeSignPad } from './helpers/CustomeSignPad';
import { Card, CardActions, CardContent, Grid, Typography, InputLabel, FormHelperText } from '@material-ui/core';
import { DateTimePicker, SecondaryButton, TextBox, MandatoryField } from '../../../../../../../Core/Controls';
import { getWheelTorque, postWheelTorque } from './helpers/wheel-services';
import { AppContext } from '../../../../../../../Core/App/PageLevel/AppContextProvider';
import BorderColor from '@material-ui/icons/BorderColor';

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 275,
        textAlign: 'left',
        transition: '0.3s ease',
        marginTop: 8,
        padding: '0px'
    },
    header: {
        color: theme.palette?.primary?.main || '#3f51b5',
        borderBottom: `2px solid ${theme.palette?.primary?.main || '#3f51b5'}`,
        paddingBottom: '4px',
        fontWeight: 600,
        fontSize: '0.95rem',
        marginBottom: 10,
        textTransform: 'uppercase',
        textAlign: 'left'
    }
}));

function OutlinedCard(props) {
    const {
        heading,
        state,
        setTorque,
        torque,
        objName,
        fromStep,
        navigateToDashboard,
        DefaultName,
        setShowDwnld,
        nextMileageName,
        nextMileageColumn,
        isDisabled
    } = props;
    const errors = props.errors || {};
    const classes = useStyles();
    const appContext = useContext(AppContext);
    const showToast = appContext?.showToast || appContext?.toastState?.showToast;

    const handleInput = (e) => {
        const { name, value } = e.target;
        setTorque((st) => {
            let newSt = { ...st };
            if (name == 'nm') {
                let Totallbft = 0.7376 * +value;
                newSt[objName] = { ...st[objName], [name]: value, lbft: +Totallbft?.toFixed(2) };
            } else {
                newSt[objName] = { ...st[objName], [name]: value };
            }
            return newSt;
        });
    };

    const fieldChange = (val) => {
        setTorque((st) => {
            let newSt = { ...st };
            newSt[objName] = { ...st[objName], ...val };
            return newSt;
        });
    };

    const setDefaultName = () => {
        setTorque((st) => {
            let newSt = { ...st };
            newSt[objName] = { ...st[objName], pn: DefaultName };
            return newSt;
        });
    };

    const clearSig = (val) => {
        setTorque((st) => {
            let newSt = { ...st };
            newSt[objName] = { ...st[objName], signature: null, sign: null };
            return newSt;
        });
    };

    useEffect(() => {
        if (state.signature) {
            setShowDwnld(true);
        }
    }, [state.signature]);

    let isSignDisabled = false;
    let isSignButtonDisplay = true;

    return (
        <div className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography className={classes.header}>{heading}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputLabel error={!!errors.nm} style={{ fontSize: 12, marginBottom: 4 }} className="mandatoryfields">
                        Wheel Nuts Torqued to*
                    </InputLabel>
                    <div style={{ display: 'flex' }}>
                        <div>
                            <TextBox placeholder="Nm" type="number" name="nm" value={state.nm} onChange={handleInput} disabled={isDisabled} />
                        </div>
                        <div>&nbsp;</div>
                        <div>
                            <TextBox placeholder="Lbft" type="number" name="lbft" value={state.lbft} onChange={handleInput} disabled={true} />
                        </div>
                    </div>
                    {errors.nm && (
                        <FormHelperText error style={{ marginTop: 0 }}>
                            {errors.nm}
                        </FormHelperText>
                    )}
                </Grid>
                <Grid item xs={12} sm={6} className="mandatory-fields">
                    <MandatoryField
                        inputLabel={nextMileageName}
                        name="vm"
                        type="number"
                        value={state.vm}
                        onChange={handleInput}
                        isDisabled={isDisabled}
                        errors={errors.vm}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <InputLabel error={!!errors.date} shrink className="mandatoryfields">
                        Date*
                    </InputLabel>
                    <DateTimePicker name="date" value={state.date} onChange={handleInput} disabled={isDisabled} />
                    {errors.date && (
                        <FormHelperText error style={{ marginTop: 0 }}>
                            {errors.date}
                        </FormHelperText>
                    )}
                </Grid>
                {/* {nextMileageName && (
                    <Grid item xs={12} sm={6}>
                        <div className="labelTextReq" style={{ fontSize: 12 }}>
                            {nextMileageName}
                        </div>
                        <TextBox name={nextMileageColumn} type="number" value={state[nextMileageColumn]} onChange={handleInput} disabled={isDisabled} />
                        <FormHelperText error style={{ marginTop: 0 }}>
                            {errors[nextMileageColumn]}
                        </FormHelperText>
                    </Grid>
                )} */}
                <Grid item xs={12}>
                    <Typography style={{ fontWeight: 500 }}> {heading} COMPLETED BY : </Typography>
                </Grid>
                <Grid item xs={12} className="mandatory-fields">
                    <MandatoryField
                        inputLabel={
                            <span>
                                Print Name &nbsp;
                                {isSignButtonDisplay && !state.pn && !isDisabled && (
                                    <BorderColor
                                        onClick={setDefaultName}
                                        toolTipTitle="Use User Name"
                                        fontSize="small"
                                        style={{ marginBottom: -4, cursor: 'pointer' }}
                                    />
                                )}
                            </span>
                        }
                        name="pn"
                        value={state.pn}
                        onChange={handleInput}
                        isDisabled={isDisabled}
                        errors={errors.pn}
                    />
                </Grid>
                <Grid item xs={12}>
                    <CustomeSignPad
                        style={{ marginTop: -12 }}
                        onChange={fieldChange}
                        clearSig={clearSig}
                        content={<InputLabel error className="mandatoryfields"> Signature*</InputLabel>}
                        sign={state.sign}
                        name="signature"
                        hideBtn={isSignDisabled || isDisabled}
                        disabled={isSignDisabled || isDisabled}
                    />
                    <FormHelperText error shrink style={{ marginTop: 0 }}>
                        {errors.sign}
                    </FormHelperText>
                </Grid>
            </Grid>
        </div>
    );
}

const WheelTorque = () => {
    const {
        vehicleDetails,
        torqueState: torque,
        setTorqueState: setTorque,
        validationErrors,
        setValidationErrors,
        headerId,
        DefaultName,
        urlParams,
        fromStep,
        navigateToDashboard,
        isDisabled
    } = useContext(WheelAndTorqueContext);

    const appContext = useContext(AppContext);
    const showToast = appContext?.showToast || appContext?.toastState?.showToast;
    const [view, setView] = useState(false);

    return (
        <div style={{ padding: '0px 8px', position: 'relative' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <OutlinedCard
                        regNO={vehicleDetails.regNo}
                        heading="FITTING TORQUE"
                        objName="fittingTorque"
                        state={torque.fittingTorque}
                        setTorque={setTorque}
                        torque={torque}
                        DefaultName={DefaultName}
                        setShowDwnld={setView}
                        nextMileageName="Torque Mileage"
                        nextMileageColumn="reTorqueMileageRequired"
                        fromStep={fromStep}
                        navigateToDashboard={navigateToDashboard}
                        errors={{
                            pn: validationErrors.fittingTorquePn,
                            sign: validationErrors.fittingTorqueSign,
                            nm: validationErrors.fittingTorqueNm,
                            vm: validationErrors.fittingTorqueVm,
                            date: validationErrors.fittingTorqueDate
                        }}
                        isDisabled={isDisabled}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <OutlinedCard
                        regNO={vehicleDetails.regNo}
                        heading="RE-TORQUE"
                        objName="reTorque"
                        state={torque.reTorque}
                        setTorque={setTorque}
                        torque={torque}
                        DefaultName={DefaultName}
                        setShowDwnld={setView}
                        nextMileageName="Re-Torque Mileage"
                        nextMileageColumn="reTorqueMileageRequired"
                        fromStep={fromStep}
                        navigateToDashboard={navigateToDashboard}
                        errors={{
                            pn: validationErrors.reTorquePn,
                            sign: validationErrors.reTorqueSign,
                            nm: validationErrors.reTorqueNm,
                            vm: validationErrors.reTorqueVm,
                            date: validationErrors.reTorqueDate
                        }}
                        isDisabled={isDisabled}
                    />
                </Grid>
            </Grid>
            {/* Submit is handled by parent index.jsx */}
        </div>
    );
};

export default WheelTorque;
